import Tasks from "./Tasks";

export default Tasks; 